import { Injectable, inject } from "@angular/core";
import { ConfirmModalConfig, ConfirmModalStateModel } from "./ConfirmModalModel";
import { ConfirmModalState } from "./ConfirmModalState";

const DEFAULT_CONFIRM_TEXT = "Confirm";
const DEFAULT_CANCEL_TEXT = "Cancel";

@Injectable({ providedIn: "root" })
export class ConfirmModalEffects {
  private readonly modalState = inject(ConfirmModalState);

  open(config: ConfirmModalConfig): void {
    const modal: ConfirmModalStateModel = {
      isOpen: true,
      title: config.title,
      message: config.message,
      confirmText: config.confirmText ?? DEFAULT_CONFIRM_TEXT,
      cancelText: config.cancelText ?? DEFAULT_CANCEL_TEXT,
      variant: config.variant ?? "primary",
      closeOnOverlay: config.closeOnOverlay ?? true,
      isLoading: false,
      onConfirm: config.onConfirm,
      onCancel: config.onCancel,
    };
    this.modalState.setModal(modal);
  }

  async confirm(): Promise<void> {
    const modal = this.modalState.data();
    if (!modal || modal.isLoading) {
      return;
    }

    this.modalState.setLoading(true);
    try {
      if (modal.onConfirm) {
        await modal.onConfirm();
      }
      this.modalState.clear();
    } catch (error) {
      console.error("Confirm modal confirm failed", error);
      this.modalState.setLoading(false);
    }
  }

  async cancel(): Promise<void> {
    const modal = this.modalState.data();
    if (!modal || modal.isLoading) {
      return;
    }

    try {
      if (modal.onCancel) {
        await modal.onCancel();
      }
    } catch (error) {
      console.error("Confirm modal cancel failed", error);
    } finally {
      this.modalState.clear();
    }
  }

  close(): void {
    this.modalState.clear();
  }
}
